import { useState } from "react";
import { Tooltip, IconButton, ClickAwayListener } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";

export default function CompTooltip({ message }) {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(true); // เปิด tooltip เมื่อคลิก
  };

  const handleClickAway = () => {
    setOpen(false); // ปิด tooltip เมื่อคลิกนอก tooltip
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div style={{ display: "inline-block" }}>
        <Tooltip
          title={message}
          open={open}
          onOpen={() => setOpen(true)}   // เมื่อ hover -> เปิด tooltip
          onClose={() => setOpen(false)} // เมื่อออก hover หรือ click away -> ปิด
          componentsProps={{
            tooltip: {
              sx: {
                fontSize: "14px",
                maxWidth: 280,
                whiteSpace: "pre-wrap",
              },
            },
          }}
        >
          <IconButton onClick={handleClick}>
            <ErrorIcon color="error" />
          </IconButton>
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
}
